import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { Field } from 'formik';
import { I18N } from 'commons';
import ErrorMessage from './ErrorMessage';

const FieldSection = ({
  name, type, title, className, isOptional, values, touched, errors, isDisable, ...props
}) => {
  const hasTouched = _.has(touched, name) && !!touched[name];
  const hasError = _.has(errors, name) && !!errors[name];
  const a11yAttributes = (hasTouched && hasError) ? {
    'aria-invalid': true,
    'aria-labelledby': `${name}Label`
  } : {
    'aria-labelledby': `${name}Label`
  };
  return (
    <div className={className}>
      <label className="col-form-label" htmlFor={name}>
        <span id={`${name}Label`}><I18N>{title}</I18N>
          {
            !isOptional &&
            <span className="sr-only"><I18N>information.label.required</I18N></span>
          }
        </span>
        {
          !isOptional &&
            <span aria-hidden="true" className="required-star">*</span>
        }
      </label>
      <div>
        <Field
          autoComplete="off"
          disabled={isDisable}
          type={type}
          name={name}
          id={name}
          className="form-control"
          value={values[name]}
          required={!isOptional}
          {...props}
          {...a11yAttributes}
        />
      </div>
      {hasTouched && hasError &&
        <div>
          <ErrorMessage id={`${name}Desc`} aria-hidden="true">{errors[name]}</ErrorMessage>
        </div>
      }
    </div>
  );
};

FieldSection.propTypes = {
  name: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  className: PropTypes.string.isRequired,
  values: PropTypes.shape().isRequired,
  touched: PropTypes.shape().isRequired,
  errors: PropTypes.shape().isRequired,
  type: PropTypes.string,
  isOptional: PropTypes.bool,
};

FieldSection.defaultProps = {
  type: 'text',
  isOptional: false,
};

export default FieldSection;
